import { Select } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import { InputStyled } from "./form-item-string";
import styled from "styled-components";

const ReadOnlySelectStyled = styled(Select)`
  .ant-select-selector {
    background: none !important;
  }

  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88) !important;
    background: none !important;
  }

  .ant-select-arrow {
    display: none;
  }
`

function FormItemEnum({ value, onChange, readOnly, disabled, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly
  
  return <>
    { !effectiveReadOnly && <Select allowClear value={value} onChange={onChange} disabled={readOnly || disabled} options={typeData?.options} showSearch={typeData?.showSearch} mode={typeData.multiple ? "multiple" : undefined} />}
    { effectiveReadOnly && !typeData.multiple && <InputStyled value={(typeData?.options || []).find(v => v.value === value)?.label || value} readOnly />}
    { effectiveReadOnly && typeData.multiple && <ReadOnlySelectStyled value={value} options={typeData?.options} disabled mode="multiple" />}
  </>
}

export default FormItemEnum;